export default __webpack_public_path__ + "static/media/arm_length.32910492.webp";